/**
 * Плашка «очередь показана не целиком» (№319): серверная выборка упёрлась в
 * потолок, часть позиций в очередь не попала — нужно сузить фильтры.
 */
export function QueueTruncatedNotice({ limit }: { limit: number }) {
  return (
    <div
      role="status"
      className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
    >
      Показаны не все позиции (первые {limit.toLocaleString('ru-RU')}) — сузьте фильтры
    </div>
  )
}
